<template>
  <div class="table-responsive">
    <br>
    <div class="btn-group" role="group" aria-label="Buttons">
      <!-- <button class="btn btn-default" type="button" name="options" v-on:click="exportxls" autocomplete="off" checked> Excel</button> -->
      <button
        class="btn btn-default"
        v-if="org['curOrg']['role'] == '1' || org['curOrg']['role'] == '2' || org['curOrg']['role'] == 99"
        type="button"
        name="options"
        v-on:click="exportcsv"
        autocomplete="off"
      >CSV</button>
      <!-- <button class="btn btn-default" type="button" name="options" v-on:click="exporttxt" autocomplete="off"> Text</button> -->
      <button
        class="btn btn-default"
        type="button"
        name="options"
        v-on:click="exportpdf"
        autocomplete="off"
      >PDF</button>
    </div>
    <br>
    <table class="table table-hover" id="table" ref="table">
      <thead>
        <tr v-if="reportId == '1' || reportId == '2' || reportId == '3'">
          <th>UNIT {{this.reportName}} Report for Workflow {{this.workflow}} of {{this.$store.state.usermain.curOrg.name}}</th>
        </tr>
        <tr v-if="reportId == '4'">
          <th>UNIT {{this.reportName}} Report for Asset {{this.asset}} of {{this.$store.state.usermain.curOrg.name}}</th>
        </tr>
        <tr v-if="reportId === '5'">
          <th>UNIT {{this.reportName}} Report for Asset {{this.asset}} of {{this.$store.state.usermain.curOrg.name}}</th>
        </tr>
        <tr v-if="reportId == '6'">
          <th>UNIT {{this.reportName}} Report for User {{this.invUser}} of {{this.$store.state.usermain.curOrg.name}}</th>
        </tr>
        <tr v-if="reportId == '7'">
          <th>UNIT {{this.reportName}} Report for DateField {{this.datafield}} of {{this.$store.state.usermain.curOrg.name}}</th>
        </tr>
        <tr>
          <th>Organization Description: {{this.orgDescription['.value']}}</th>
        </tr>
        <tr v-if="reportId == '1' || reportId == '2'">
          <th>Workflow Description: {{this.workflowDescription}}</th>
        </tr>
        <tr v-if="reportId != '7'">
          <th>From {{this.start_format}} to {{this.end_format}}</th>
        </tr>
        <tr>
          <table>
            <th
              v-for="key in columns"
              @click="sortBy(key)"
              :class="{ active: sortKey == key }"
            >{{ key | capitalize }}</th>
          </table>
        </tr>
      </thead>
      <tbody>
        <div v-for="entry in filteredData" :class="entry.status">
          <div v-switch="reportId">
            <div v-case="'1'">
              <tr>
                <table>
                  <td>{{entry.start_time}}</td>
                  <td>{{entry['.key']}}</td>
                  <td>{{entry.completed_by}}</td>
                  <td>{{entry.late_reason}}</td>
                </table>
              </tr>
              <tr v-if="entry.tasks != null">
                <table>
                  <thead>
                    <th></th>
                    <th></th>
                    <th>Task</th>
                    <th>Time</th>
                    <th>Completed</th>
                    <th>Note / Value</th>
                    <th>Attributes</th>
                  </thead>
                  <tbody>
                    <tr
                      v-for="entryy in entry.tasks"
                      v-if="typeof entry.tasks.indexOf === 'function'"
                    >
                      <td v-if="entryy != null"></td>
                      <td v-if="entryy != null"></td>
                      <td
                        v-if="entryy != null && ranger == true"
                      >{{getLocationTagById(entryy.id)["name"]}}</td>
                      <td
                        v-if="entryy != null && ranger != true"
                      >{{entry.tasks.indexOf(entryy) + "-" + getTaskWithoutType(tasks[getKey(entryy, entry.tasks)])["description"]}}</td>
                      <td v-if="entryy != null">{{unix_to_norm(entryy.time)}}</td>
                      <td
                        v-if="entryy != null"
                      >{{entryy.completed != null ? entryy.completed : true}}</td>
                      <td v-if="entryy != null && entryy.value != null">{{entryy.value}}{{entryy.scale === "fahrenheit" ? '°F' : ''}}</td>
                      <td v-if="entryy != null">{{entryy.note}}</td>
                      <td v-if="entryy != null && entryy.attributes != null">
                        <table>
                          <thead>
                            <th>Name</th>
                            <th>Value</th>
                          </thead>
                          <tbody>
                            <tr v-for="attribute in entryy.attributes">
                              <td v-if="entryy != null">{{attribute.name}}</td>
                              <td v-if="entryy != null">{{attribute.value}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr
                      v-for="entryy in entry.tasks"
                      v-if="typeof entry.tasks.indexOf !== 'function'"
                    >
                      <td v-if="entryy != null"></td>
                      <td v-if="entryy != null"></td>
                      <td
                        v-if="entryy != null && ranger == true"
                      >{{getLocationTagById(entryy.id)["name"]}}</td>
                      <td
                        v-if="entryy != null && ranger != true"
                      >{{getKey(entryy, entry.tasks) + "-" + getTaskWithoutType(tasks[getKey(entryy, entry.tasks)])["description"]}}</td>
                      <td v-if="entryy != null">{{unix_to_norm(entryy.time)}}</td>
                      <td v-if="entryy != null && entryy.value != null">{{entryy.value}}</td>
                      <td v-if="entryy != null">{{entryy.note}}</td>
                      <td v-if="entryy != null && entryy.attributes != null">
                        <table>
                          <thead>
                            <th>Name</th>
                            <th>Value</th>
                          </thead>
                          <tbody>
                            <tr v-for="attribute in entryy.attributes">
                              <td v-if="entryy != null">{{attribute.name}}</td>
                              <td v-if="entryy != null">{{attribute.value}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </tr>
            </div>
            <div v-case="'2'">
              <tr>
                <table>
                  <td>{{entry['.key']}}</td>
                  <td v-if="entry.shouldhavecompleted != null">{{entry.shouldhavecompleted}}</td>
                  <td v-else>
                    <table>
                      <thead>
                        <th>Task</th>
                        <th>Should have been completed at</th>
                      </thead>
                      <tbody>
                        <tr v-for="lateTask in entry['.value']">
                          <td v-if="lateTask != null">{{lateTask.description}}</td>
                          <td v-if="lateTask != null">{{unix_to_norm(lateTask.shouldhavecompleted)}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </table>
              </tr>
            </div>
            <div v-case="'3'">
              <tr>
                <table>
                  <td v-if="entry != null">{{entry.name}}</td>
                  <td v-if="entry != null">{{entry.time}}</td>
                  <td v-if="entry != null">{{entry.workflow_name}}</td>
                  <td v-if="entry != null">{{entry.completed_by}}</td>
                  <td v-if="entry != null">{{entry.note}}</td>
                  <td v-if="entry != null && entry.attributes != null">
                    <table>
                      <thead>
                        <th>Name</th>
                        <th>Value</th>
                      </thead>
                      <tbody>
                        <tr v-for="attribute in entry.attributes">
                          <td v-if="entry != null">{{attribute.name}}</td>
                          <td v-if="entry != null">{{attribute.value}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </table>
              </tr>
            </div>
            <div v-case="'4'">
              <tr>
                <table>
                  <td v-if="entry != null">{{entry.completed_by}}</td>
                  <td v-if="entry != null">{{entry.time}}</td>
                  <td v-if="entry != null">{{entry.incident}}</td>
                  <td v-if="entry != null">{{entry.reason}}</td>
                </table>
              </tr>
            </div>
            <div v-case="'5'">
              <tr>
                <table>
                  <td v-if="entry != null">{{entry.completed_by}}</td>
                  <td v-if="entry != null">{{entry.time}}</td>
                  <td v-if="entry != null">{{entry.change}}</td>
                </table>
              </tr>
            </div>
            <div v-case="'6'">
              <tr>
                <table>
                  <td v-if="entry != null">{{entry.asset}}</td>
                  <td v-if="entry != null">{{entry.time}}</td>
                  <td v-if="entry != null">{{entry.change}}</td>
                </table>
              </tr>
            </div>
            <div v-case="'7'">
              <tr>
                <table>
                  <td v-if="entry != null">{{entry.name}}</td>
                  <td v-if="entry != null">{{entry.groups}}</td>
                  <td v-if="entry != null">{{entry.total}}</td>
                  <td v-if="entry != null">{{entry.allocated}}</td>
                  <td v-if="entry != null">{{entry.location}}</td>
                </table>
              </tr>
            </div>
          </div>
        </div>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from "jquery";
import jQuery from "jQuery";
window.jQuery = jQuery;
import filesaverjs from "file-saverjs";
import database from "../webmaster/Database/database";
import html2pdf from "../../../static/assets/js/html2pdf.bundle.min.js";
import { vSwitch, vCase, vDefault } from "v-switch-case";
import store from "../webmaster/Store/vuex";

export default {
  name: "datatable",
  directives: {
    switch: vSwitch,
    case: vCase,
    default: vDefault
  },
  props: {
    reportName: String,
    reportId: String,
    data: Array,
    columns: Array,
    workflow: String,
    workflowDescription: String,
    end: Date,
    start: Date,
    tasks: Array,
    ranger: Boolean,
    incident: String,
    asset: String,
    invUser: String,
    datafield: String,
  },
  data: function() {
    var sortOrders = {};
    this.columns.forEach(function(key) {
      sortOrders[key] = 1;
    });
    return {
      Jdata: {},
      sortKey: "",
      orgDescription: "",
      sortOrders: sortOrders,
      user: [],
      start_format: "",
      end_format: "",
      locationTags: [],
      org: store.state.usermain
    };
  },
  computed: {
    filteredData: function() {
      var sortKey = this.sortKey;
      var order = this.sortOrders[sortKey] || 1;
      var data = this.data;

      this.start_format = this.unix_to_norm(this.start / 1000);
      this.end_format = this.unix_to_norm(this.end / 1000);

      if (this.ranger) {
        this.$bindAsArray(
          "locationTags",
          database
            .getRef(
              "/orgs/" + this.$store.state.usermain.curOrg.id + "/devices"
            )
            .orderByChild("type")
            .equalTo("Location Tag")
        );
      }

      switch (this.reportId) {
        case "1":
          for (var key in data) {
            var ref =
              "/orgs/" +
              this.$store.state.usermain.curOrg.id +
              "/users/" +
              data[key]["completed_by"];

            
            this.$bindAsArray(
              "user",
              database.getRef(
                ref
              ) /*.orderByChild('type').equalTo('Mobile Device')*/
            );
            var index = this.user.findIndex(x => x[".key"] == "name");
            data[key]["completed_by"] = this.user[index][".value"];
            delete data[key]["completed_by_device"];
            delete data[key]["completed"];

            data[key][".key"] = this.unix_to_norm(data[key][".key"]);
            
            if (data[key]["start_time"] != null) {
              data[key]["start_time"] = this.unix_to_norm(
                data[key]["start_time"]
              );
            } else {
              data[key]["start_time"] = "Null";
            }
          }

          return data;
          break;
        case "2":
          for (var key in data) {
            if (!data[key]["filtered"]) {
              data[key][".key"] = this.unix_to_norm(data[key][".key"]);

              if (data[key]["shouldhavecompleted"] != null) {
                data[key]["shouldhavecompleted"] = this.unix_to_norm(
                  data[key]["shouldhavecompleted"]
                );
              }
              data[key]["filtered"] = true;
            }
          }

          return data;
          break;
        case "3":
          for (var key in data) {
            if (!data[key]["filtered"]) {
              var ref =
                "/orgs/" +
                this.$store.state.usermain.curOrg.id +
                "/users/" +
                data[key]["completed_by"];
              this.$bindAsArray("user", database.getRef(ref));
              var index = this.user.findIndex(x => x[".key"] == "name");
              data[key]["completed_by"] = this.user[index][".value"];
              delete data[key]["completed_by_device"];
              delete data[key]["completed"];

              data[key][".key"] = this.unix_to_norm(data[key][".key"]);

              if (data[key]["time"] != null) {
                data[key]["unfilteredtime"] = data[key]["time"];
                data[key]["time"] = this.unix_to_norm(data[key]["time"]);
              }
              data[key]["filtered"] = true;
            }
          }

          return data.slice().sort((a, b) => {
            return a["unfilteredtime"] - b["unfilteredtime"];
          });

          break;
        default:
          return data;
      }
    }
  },
  filters: {
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  created: function() {
    this.$bindAsObject(
      "orgDescription",
      database.getRef(
        "/meta_orgs/" + this.$store.state.usermain.curOrg.id + "/description/"
      )
    );
  },
  methods: {
    JSONToCSVConvertor: function(
      JSONData,
      ReportTitle,
      WorkflowDescription,
      OrgDescription,
      ShowLabel
    ) {
      //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

      var CSV = "";
      //Set Report title in first row or line

      CSV += ReportTitle + "\r\n";
      CSV += "Organization Description: " + OrgDescription + "\r\n";
      if (this.reportId != "3") {
        CSV += "Workflow Description: " + WorkflowDescription + "\r\n";
      }
      CSV += "From " + this.start_format + " to " + this.end_format + "\r\n\n";

      //This condition will generate the Label/Header
      if (ShowLabel) {
        var row = "";
        switch (this.reportId) {
          case "1":
            row += "COMPLETED BY" + ",";
            row += "START TIME" + ",";
            row += "END TIME" + ",";
            row += "LATE REASON" + ",";

            break;
          case "2":
            row += "LATE AT" + ",";
            row += "SHOULD HAVE BEEN COMPLETED AT" + ",";

            break;
          case "3":
            row += "TASK" + ",";
            row += "TIME" + ",";
            row += "WORKFLOW" + ",";
            row += "COMPLETED BY" + ",";
            row += "NOTE / VALUE" + ",";
            row += "ATTRIBUTES" + ",";

            break;
        }

        row = row.slice(0, -1);
        //append Lab"el row with line break
        CSV += row + "\r\n";
      }

      switch (this.reportId) {
        case "1":
          //1st loop is to extract each row
          for (var i = 0; i < arrData.length; i++) {
            var row = "";
            var taskrows = [];
            var taskrow = "";

            //2nd loop will extract each column and convert it in string comma-seprated
            if (arrData[i]["tasks"] != null) {
              for (var indexx in arrData[i]["tasks"]) {
                taskrow = "";
                taskrow += '"' + " " + '",';

                var attributerows = [];

                if (indexx != "0") {
                  if (this.ranger) {
                   if (arrData[i]["tasks"][indexx] == null) {
                      taskrow +=
                        '"' +
                        '' +
                        '",';
                    } else {
                      taskrow +=
                        '"' +
                        this.getLocationTagById(
                          arrData[i]["tasks"][indexx]["id"]
                        )["name"] +
                        '",';
                    }
                  } else {
                    taskrow +=
                      '"' +
                      (indexx +
                        "-" +
                        this.getTaskWithoutType(this.tasks[indexx])[
                          "description"
                        ]) +
                      '",';
                  }
                }
                if (arrData[i]["tasks"][indexx] != null) {
                  if (arrData[i]["tasks"][indexx]["completed"] == undefined) {
                    arrData[i]["tasks"][indexx]["completed"] = true;
                  }

                  if (arrData[i]["tasks"][indexx]["note"] != null) {
                    taskrow += '"' + arrData[i]["tasks"][indexx]["note"] + '",';
                  } else {
                    if (arrData[i]["tasks"][indexx]["value"] != null) {
                      if (arrData[i]["tasks"][indexx]["scale"] === "fahrenheit") {
                        taskrow += '"' + arrData[i]["tasks"][indexx]["value"].toString() + ' degrees F' + '",';
                      } else {
                        taskrow += '"' + arrData[i]["tasks"][indexx]["value"] + '",';
                      }
                    } else {
                      taskrow += '"' + " " + '",';
                    }
                  }
                  taskrow +=
                    '"' + arrData[i]["tasks"][indexx]["completed"] + '",';
                  taskrow +=
                    '"' +
                    this.unix_to_norm(arrData[i]["tasks"][indexx]["time"]) +
                    '",';

                  if (arrData[i]["tasks"][indexx]["attributes"]) {
                    var attributerow = "";
                    for (var attribute in arrData[i]["tasks"][indexx][
                      "attributes"
                    ]) {
                      attributerow = "";
                      attributerow +=
                        '" "," "," "," "," ",' +
                        '"' +
                        arrData[i]["tasks"][indexx]["attributes"][attribute][
                          "name"
                        ] +
                        '",';
                      attributerow +=
                        '"' +
                        arrData[i]["tasks"][indexx]["attributes"][attribute][
                          "value"
                        ] +
                        '",';

                      attributerows.push(attributerow);
                    }
                  }
                }

                if (attributerows.length != 0) {
                  taskrow += '"NAME","VALUE",';
                }
                taskrows.push(taskrow);
                for (var arow in attributerows) {
                  taskrows.push(attributerows[arow]);
                }
              }
            }

            row += '"' + arrData[i]["completed_by"] + '",';
            row += '"' + arrData[i]["start_time"] + '",';
            row += '"' + arrData[i][".key"] + '",';
            if (arrData[i]["late_reason"] != undefined) {
              row += '"' + arrData[i]["late_reason"] + '",';
            }

            //NEVER REMOVE
            row.slice(0, row.length - 1);

            //add a line break after each row
            CSV += row + "\r\n";

            if (arrData[i]["tasks"] != null) {
              if (this.ranger) {
                taskrows.unshift(
                  '" ","TASK","NOTE / VALUE","COMPLETED","TIME","ATTRIBUTES",'
                );
              } else {
                taskrows[0] =
                  '" ","TASK","NOTE / VALUE","COMPLETED","TIME","ATTRIBUTES",';
              }
            }
            for (var index in taskrows) {
              //console.log(taskrows[index])
              CSV += taskrows[index] + "\r\n";
            }

            CSV += "\n";
          }
          break;
        case "2":
          //1st loop is to extract each row
          for (var i = 0; i < arrData.length; i++) {
            var row = "";
            var lateTaskrows = [];
            var lateTaskrow = "";

            row += '"' + arrData[i][".key"] + '",';

            if (arrData[i]["shouldhavecompleted"] != null) {
              row += '"' + arrData[i]["shouldhavecompleted"] + '",';
            } else {
              row += '"TASK","SHOULD HAVE BEEN COMPLETED AT",';
              for (var lateTask in arrData[i][".value"]) {
                lateTaskrow = "";
                lateTaskrow += '"' + " " + '",';

                lateTaskrow +=
                  '"' + arrData[i][".value"][lateTask]["description"] + '",';
                lateTaskrow +=
                  '"' +
                  this.unix_to_norm(
                    arrData[i][".value"][lateTask]["shouldhavecompleted"]
                  ) +
                  '",';

                lateTaskrows.push(lateTaskrow);
              }
            }

            row.slice(0, row.length - 1);
            //add a line break after each row
            CSV += row + "\r\n";
            for (var index in lateTaskrows) {
              //console.log(taskrows[index])
              CSV += lateTaskrows[index] + "\r\n";
            }

            CSV += "\n";
          }

          break;
        case "3":
          var tasksrows = [];

          //1st loop is to extract each row
          for (var i = 0; i < arrData.length; i++) {
            var taskrow = "";
            var attributerows = [];

            var newrows = [];

            taskrow += '"' + arrData[i]["name"] + '",';
            taskrow += '"' + arrData[i]["time"] + '",';
            taskrow += '"' + arrData[i]["workflow_name"] + '",';
            taskrow += '"' + arrData[i]["completed_by"] + '",';
            if (arrData[i]["note"]) {
              taskrow += '"' + arrData[i]["note"] + '",';
            } else {
              taskrow += '"' + " " + '",';
            }
            if (arrData[i]["attributes"]) {
              for (var attribute in arrData[i]["attributes"]) {
                attributerow = "";
                attributerow +=
                  '" "," "," "," "," ",' +
                  '"' +
                  arrData[i]["attributes"][attribute]["name"] +
                  '",';
                attributerow +=
                  '"' + arrData[i]["attributes"][attribute]["value"] + '",';

                attributerows.push(attributerow);
              }
            }

            if (attributerows.length != 0) {
              taskrow += '"NAME","VALUE",';
            }

            newrows.push(taskrow + "\r\n");

            //CSV += taskrow + "\r\n";
            for (var arow in attributerows) {
              //CSV += attributerows[arow] + "\r\n";
              newrows.push(attributerows[arow] + "\r\n");
            }

            tasksrows.push({
              date: Date.parse(arrData[i]["time"].replace("at", "")),
              value: newrows
            });

            //CSV += "\n";
          }

          tasksrows.sort(function(a, b) {
            return a["date"] - b["date"];
          })

          tasksrows.forEach(function(rowmap) {
            rowmap["value"].forEach(function(row) {
              CSV += row + "\r\n";
            })
          })

          break;
      }

      if (CSV == "") {
        alert("Invalid data");
        return;
      }

      var csvData = new Blob([CSV], { type: 'text/csv' }); //new way
      var csvUrl = URL.createObjectURL(csvData);

            //this trick will generate a temp <a /> tag
      var link = document.createElement("a");
      link.href = csvUrl;

      //set the visibility hidden so it will not effect on your web-layout
      link.style = "visibility:hidden";

      switch (this.reportId) {
        case "3":
          link.download = this.filteredData[0]["name"] + "_Report.csv";

          break;
        default:
          link.download = this.workflow + "_Report.csv";
          break;
      }

      //this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    unix_to_norm: function(unix) {
      var date = new Date(unix * 1000);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var time = hours + ":" + minutes + " " + ampm;
      return (
        parseInt(date.getMonth()) +
        1 +
        "/" +
        date.getDate() +
        "/" +
        date.getFullYear() +
        " at " +
        time
      );
    },

    getKey: function(entrry, tasks) {
      for (var key in tasks) {
        if (tasks[key] == entrry) return key;
      }
    },

    getTaskWithoutType: function(task) {
      switch (Object.keys(task)[0]) {
        case "locationtag":
          return task["locationtag"];
          break;
        case "input":
          return task["input"];
          break;
        case "temperature":
          return task["temperature"];
          break;
      }
    },

    getLocationTagById: function(id) {
      for (var tag in this.locationTags) {
        if (this.locationTags[tag][".key"] == id) {
          return this.locationTags[tag];
        }
      }
    },

    exportxls: function() {
      this.Jdata = JSON.stringify(this.data);

      this.JSONToCSVConvertor(
        this.Jdata,
        "UNIT " +
          this.reportName +
          " Report for Workflow " +
          this.workflow +
          " of " +
          this.$store.state.usermain.curOrg.name,
        this.workflowDescription,
        this.orgDescription[".value"],
        true
      );
    },

    exportcsv: function() {
      if (
        this.org["curOrg"]["role"] == "1" ||
        this.org["curOrg"]["role"] == "2" ||
        this.org["curOrg"]["role"] == 99
      ) {
        this.Jdata = JSON.stringify(this.data);

        this.JSONToCSVConvertor(
          this.Jdata,
          "UNIT " +
            this.reportName +
            " Report for Workflow " +
            this.workflow +
            " of " +
            this.$store.state.usermain.curOrg.name,
          this.workflowDescription,
          this.orgDescription[".value"],
          true
        );
      }
    },
    exporttxt: function() {
      //REMOVED BECAUSE I REMOVED THE PACKAGE - "tableexport"
      /*var instance = new TableExport(document.getElementById("table"), {
        formats: ["txt"],
        headers: true,
        exportButtons: false
      });

      var exportData = instance.getExportData()["table"]["txt"];

      //                   // data          // mime              // name              // extension
      instance.export2file(
        exportData.data,
        exportData.mimeType,
        exportData.filename,
        exportData.fileExtension
      ); */
    },
    exportpdf: function() {
      var timeDiff = Math.abs(this.end.getTime() - this.start.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      //console.log(diffDays);
      if (diffDays <= 1 || this.reportId == "7") {
        var element = this.$refs.table;
        html2pdf(element, {
          margin: 10,
          filename: this.workflow + "_Report.pdf"
        });
      } else {
        alert("For any report larger than a day, please run a CSV report");
      }
    },
    sortBy: function(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dropdown {
  margin-right: default;
}
th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
}

.btn-group {
  float: right;
}
</style>



// WEBPACK FOOTER //
// DataTable.vue?9cabe666